/**
 * Constants for PaymentPickup feature
 * Centralized configuration values to avoid magic numbers
 */

export const PICKUP_CONSTANTS = {
    // Form validation
    MAX_NOTE_LENGTH: 255,
    MIN_PAYMENT_AMOUNT: 0,

    // Date filtering
    ALL_WEEK_DAYS: [0, 1, 2, 3, 4, 5, 6],

    // Timezone
    TIMEZONE: 'America/Los_Angeles',
};

export const ERROR_MESSAGES = {
    MISSING_DATE: 'Please select a pickup date.',
    MISSING_AMOUNT: 'Please enter the pickup amount.',
    INVALID_AMOUNT: 'Please enter a valid pickup amount.',
    AMOUNT_TOO_LOW: 'Pickup amount must be greater than 0.',
    AMOUNT_EXCEEDS_DUE: 'Pickup amount cannot exceed the due amount of',
    MISSING_CUSTOMER: 'Customer information is missing.',
    SUBMISSION_FAILED: 'Failed to submit pickup request. Please try again.',
};

export const SUCCESS_MESSAGES = {
    SUBMISSION_SUCCESS: 'Pickup request submitted successfully!',
};

